/** @jsx h */
import { h } from 'preact'

const Loading = () => (
  <div class='Loading'>
    <div class='Loading-icon'>
      <span class='Loading-iconElement' />
      <span class='Loading-iconElement' />
      <span class='Loading-iconElement' />
      <span class='Loading-iconElement' />
      <span class='Loading-iconElement' />
      <span class='Loading-iconElement' />
      <span class='Loading-iconElement' />
      <span class='Loading-iconElement' />
      <span class='Loading-iconElement' />
      <span class='Loading-iconElement' />
      <span class='Loading-iconElement' />
      <span class='Loading-iconElement' />
    </div>
    <p class='Loading-copy'>Loading...</p>
  </div>
)

export default Loading
